<template>
  <div id="persona-juridica">
    <div class="row">
      <LmSelect
        class="col-12 col-lg-6"
        v-model="form.tipoSociedad"
        :v="validation.tipoSociedad"
        :options="tipoSociedades"
        label="Tipo Sociedad"
        :disabled="isOnEditMode"
      />
      <LmTextInput
        class="col-12 col-lg-6"
        v-model="form.razonSocial"
        :v="validation.razonSocial"
        label="Razón Social"
        placeholder="Razón Social"
        :disabled="isOnEditMode"
        />
      <LmTextInput
        class="col-12 col-lg-6"
        v-model="form.cuit"
        :v="validation.cuit"
        label="CUIT"
        placeholder="CUIT"
        :disabled="isOnEditMode"
        />
      <LmTextInput
        class="col-12 col-lg-6"
        v-model="form.domiciolioComercio"
        :v="validation.domiciolioComercio"
        label="Domicilio"
        placeholder="Domicilio"
        :disabled="isOnEditMode"
        />
      <LmEmailInput
        class="col-12 col-lg-6"
        v-model="form.emailComercio"
        :v="validation.emailComercio"
        label="Mail"
        placeholder="Mail del Comercio"
        :disabled="isOnEditMode"
        />
    </div>
  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
export default {
  components: {
    LmSelect,
    LmTextInput,
    LmEmailInput
  },
  data () {
    return {
      tipoSociedades: {
        disabledOption: 'Seleccione el Tipo de Sociedad',
        content: ['SA', 'SRL', 'SH', 'SAS', 'SAU', 'SCS', 'SCA']
      }
    }
  },
  props: {
    validation: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
